import { Banner5050 } from '@/design-system/molecules/Banner5050';
import { themeIntegration } from '@/utils/themeIntegration';

const IntegrationBanner5050 = (props) => {
    return themeIntegration(Banner5050, props);
};

export default IntegrationBanner5050;
